import React, { useEffect, useState } from "react";
import { Row, Space } from "antd";
import ReactLoading from "react-loading";
import "@fontsource/fira-sans";

import "./App.css";


import MapComponent from "./components/MapComponent";
import MenuComponent from "./components/MenuComponent";

function App() {
  // States
  const [dataFiltered, setDataFiltered] = useState([]);
  const [topologia, setTopologia] = useState({});
  const [topologiaGS, setTopologiaGS] = useState({});
  const [baseTopo, setBaseTopo] = useState({});
  const [dataProyectada, setDataProyectada] = useState([]);
  const [tipoMapa, setTipoMapa] = useState("País");
  const [dataLoaded, setDataLoaded] = useState(false);

  const [regionSelect, setRegionSelect] = useState(
    "Región de Arica y Parinacota"
  );
  const [annoSelect, setAnnoSelect] = useState(2002);

  const regiones = [
    "Región de Arica y Parinacota",
    "Región de Tarapacá",
    "Región de Antofagasta",
    "Región de Atacama",
    "Región de Coquimbo",
    "Región de Valparaíso",
    "Región Metropolitana de Santiago",
    "Región del Libertador Bernardo O'Higgins",
    "Región del Maule",
    "Región de Ñuble",
    "Región del Bío-Bío",
    "Región de La Araucanía",
    "Región de Los Ríos",
    "Región de Los Lagos",
    "Región de Aysén del Gral.Ibañez del Campo",
    "Región de Magallanes y Antártica Chilena",
  ];

  const handleAnno = async (val, dataP) => {
    setAnnoSelect(val);
    const dataFiltrada = dataP.filter((data) => parseInt(data.Año) === val);
    setDataFiltered(dataFiltrada);
  };

  

  useEffect(() => {
    const getDatos = async () => {
      // Datos a mostrar

      // Comuna anno
      //https://d2w3n1ggm96xe9.cloudfront.net
      let res = await fetch("https://d109f9uztt08nv.cloudfront.net/deficit-cero/datos-deficit-cero/mapas/tasa_crecimiento_mapa.json");
      let data = await res.json();
      setDataProyectada(data);

      await handleAnno(2002, data);

      // Topologia
      res = await fetch("https://d109f9uztt08nv.cloudfront.net/colunga/viz-colunga/topo-json-mapa/topo2@1.json");
      data = await res.json();
      setTopologia(data);

      // Topologia GS
      res = await fetch("https://d109f9uztt08nv.cloudfront.net/colunga/viz-colunga/topo-json-mapa/GranSantiago3.json");
      data = await res.json();
      setTopologiaGS(data);

      // Base topo
      res = await fetch(
        "https://d109f9uztt08nv.cloudfront.net/colunga/viz-colunga/topo-json-mapa/base.topo.json"
      );
      data = await res.json();
      setBaseTopo(data);

      setDataLoaded(true);
    };

    if (~dataLoaded) {
      getDatos();
    }
  }, [dataLoaded]); // Agregar dataLoaded al arreglo de dependencias

  return (
    <div className="container">
      <Space
        direction="vertical"
        size="middle"
        style={{
          display: "flex",
        }}
      >
        <MenuComponent
          tipoMapa={tipoMapa}
          setTipoMapa={setTipoMapa}
          regiones={regiones}
          setRegionSelect={setRegionSelect}
          setAnnoSelect={setAnnoSelect}
          annoSelect={annoSelect}
          dataProyectada={dataProyectada}
          handleAnno={handleAnno}
          
        />

        <Row>
          <div className="map-container">
            {dataLoaded ? (
              <MapComponent
                tipoMapa={tipoMapa}
                dataFiltered={dataFiltered}
                topologia={topologia}
                topologiaGS={topologiaGS}
                baseTopo={baseTopo}
                dataProyectada={dataProyectada}
                regionSelect={regionSelect}
                setAnnoSelect={setAnnoSelect}
                annoSelect={annoSelect}
                handleAnno={handleAnno}
                
              />
            ) : (
              <ReactLoading
                type={"spin"}
                color="#141C72"
                height={"10%"}
                width={"10%"}
                className="loading"
              />
            )}
          </div>
          
          
          <div className="arrow-box"></div> 
        </Row>

        <Row></Row>
      </Space>
    </div>
  );
}

export default App;
